import lodash from 'lodash'
import React, { useEffect, useMemo, useRef } from 'react'
import styled from 'styled-components'

import Button from '../../../../1stlog-ui/src/components/Button'
// import Flag from "1stlog-ui/components/Flag"
import Field, {
  composeValidators,
  useField,
  useFieldContext,
} from '../../../../1stlog-ui/src/components/Field'
import Icon from '../../../../1stlog-ui/src/components/Icon'
import Input from '../../../../1stlog-ui/src/components/Input'
import { usePrevious } from '../../../../1stlog-ui/src/hooks'
import { useTariffDialog } from '../../TariffsDialog'
import TariffTree from '../../TariffTree'

const Wrapper = styled.div``

const TraceWrapper = styled.div`
  background: #f3f7f9 !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
`

const supportedZtnCountries = [
  'CH',
  'LI',
  'FR',
  'DE',
  'BE',
  'BG',
  'DK',
  'DE',
  'EE',
  'FI',
  'FR',
  'GR',
  'IE',
  'IT',
  'HR',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'AT',
  'PL',
  'PT',
  'RO',
  'SE',
  'SK',
  'SI',
  'ES',
  'CZ',
  'HU',
  'CY',
]

const Block = (props) => {
  const {
    type,
    onExportSelected = lodash.noop,
    wasExportSelected,
    resetWasExportSelected,
    exportCountry,
    importCountry,
  } = props

  const refInput = useRef()

  const countryCode = type === 'export' ? exportCountry : importCountry
  const otherCountryCode = type === 'import' ? importCountry : exportCountry
  const mode = countryCode === 'CH' ? 'tares' : 'taric'

  const { prefix: name } = useFieldContext()

  const { open: openTariffDialog, close: closeTariffDialog } =
    useTariffDialog(type)
  const { open: openOppositeTariffDialog, close: closeOppositeTariffDialog } =
    useTariffDialog(type === 'export' ? 'import' : 'export')

  const [oppositeNumber, setOppositeNumber] = useField(
    `${type === 'export' ? 'import' : 'export'}tariffNumber`,
    { asState: true },
  )
  const [number, setNumber] = useField(`${type}tariffNumber`, { asState: true })
  const [trace, setTrace] = useField(`${type}Trace`, {
    asState: true,
    validate: validateTrace,
    validates: [`${name}.${type}tariffNumber`],
    subscribeAll: true,
  })
  // const [originCountry, setOriginCountry] = useField(`${type}originCountry`, { asState: true })
  const [description, setDescription] = useField(`description`, {
    asState: true,
  })

  const previousNumber = usePrevious(number)
  useEffect(() => {
    return
    if (type === 'import') {
      return
    }
    if (!lodash.isEqual(previousNumber, number) && lodash.isString(number)) {
      // TODO: FIX THIS SHIT
      setTimeout(() => {
        setOppositeNumber(number.slice(0, 6))
        try {
          refInput.current.focus()
        } catch (err) {}
      }, 0)

      // console.log("refInput", refInput.current)
    }
  }, [number])

  const onSelect = (values) => {
    closeTariffDialog()
    const { tariffNumber, description, trace } = values || {}
    setNumber(tariffNumber)

    if (type === 'export') {
      onExportSelected(tariffNumber)
      // setDescription(description)
    }
    // TODO: set other values (description, countryOfOrigin) too

    // TODO: OPEN OTHER WIZARD if this is export
    // if (type === "export") {
    //   openOppositeTariffDialog({
    //     initialSearch: "",

    //   })
    // }
  }

  const dialogTitle =
    type === 'export'
      ? i18n.t('customs_database_for_export_from', {
          defaultValue: `Zolltarifdatenbank für Ausfuhr aus {{countryCode}}`,
          countryCode,
        })
      : i18n.t('customs_database_for_export_from', {
          defaultValue: `Zolltarifdatenbank für Einfuhr nach {{countryCode}}`,
          countryCode,
        })

  const open = () => {
    openTariffDialog({
      initialSearch: number,
      title: dialogTitle,
      onSelect,
      country: countryCode,
    })
  }

  const previousWasExportSelected = usePrevious(wasExportSelected)
  useEffect(() => {
    if (!previousWasExportSelected && wasExportSelected) {
      resetWasExportSelected()
      openTariffDialog({
        initialSearch: wasExportSelected,
        title: dialogTitle,
        isFollowup: true,
        country: countryCode,
        onSelect,
      })
    }
  }, [wasExportSelected])

  const isZtnValid = useMemo(() => {
    return !validateZtn(number, mode)
  }, [number])

  useEffect(() => {
    if (!isZtnValid) {
      setTrace(undefined)
    }
  }, [isZtnValid])

  const decoration = (
    <div style={{}} className={type === 'export' ? 'mr-3' : 'ml-3'}>
      <div className="d-flex flex-column align-items-center">
        <div className="d-flex align-items-center">
          {/* <div className="mr-2">
            <i
              className={`flag-icon flag-icon-${lodash.toLower(countryCode)}`}
            />
          </div> */}
          <Icon
            icon={
              type === 'export' ? 'fas fa-arrow-right' : 'fas fa-arrow-right'
            }
            size={1.2}
          />
        </div>
        <h5 className="">
          {/* <Icon
            icon={
              type === "export" ? "fal fa-arrow-right" : "fal fa-arrow-left"
            }
            size={1.2}
          /> */}
          {type === 'export' ? 'Ausfuhr aus' : 'Einfuhr nach'}{' '}
          <i className={`flag-icon flag-icon-${lodash.toLower(countryCode)}`} />
        </h5>
      </div>
    </div>
  )

  return (
    <Wrapper className="mt-1">
      {/* <div>
        <h1>Block</h1>
      </div> */}
      <div className="d-flex align-items-start">
        {type === 'export' && decoration}
        <div style={{ flex: '1' }}>
          <Field
            name={`${type}tariffNumber`}
            label={i18n.t('label_customs_nmb', 'Zolltarif-Nr.')}
            key={oppositeNumber}
            validate={composeValidators(
              getValidateZtn(name, type, mode, countryCode),
              type === 'import'
                ? mustMatchFirstSixDigits(oppositeNumber)
                : undefined,
            )}
            isClearable
            required
            isRequired
          >
            {(fieldProps) => (
              <div className="d-flex align-items-center">
                <div className="flex-fill">
                  {/* <ZtnAutocomplete
                    {...fieldProps}
                    mode={mode}
                  /> */}
                  <Input
                    innerRef={refInput}
                    placeholder={
                      type === 'import2222222'
                        ? 'Endziffern eingeben'
                        : 'Nr. eingeben oder Suche verwenden'
                    }
                    appendButton={
                      supportedZtnCountries.includes(countryCode) ? (
                        <Button
                          block
                          onClick={open}
                          icon="fas fa-search"
                          className="mb-2 ml-2"
                        >
                          {i18n.t(
                            'search_for_customs_tariff',
                            'Zolltarif suchen',
                          )}
                          {/* (
                        {countryCode === "CH" ? "Tares" : "Taric"}) */}
                        </Button>
                      ) : null
                    }
                    {...fieldProps}
                  />
                </div>
              </div>
            )}
          </Field>
        </div>
        {type === 'import' && decoration}
        {/* <div className="ml-2">
          <Label>&nbsp;</Label>
          <Button block onClick={open} icon="fas fa-search" className="mb-2">
            {i18n.t('search_for_customs_tariff', 'Zolltarif suchen')}
          </Button>
        </div> */}
      </div>
      {isZtnValid && (
        <TariffTree
          key={number}
          initialZtn={number}
          mode={mode}
          onTraceLoaded={setTrace}
        />
      )}
      {/* <TariffTraceValidation name={`${type}Trace`} /> */}
    </Wrapper>
  )
}

export default Block

function mustMatchFirstSixDigits(digits) {
  return (value) => {
    if (!lodash.isString(value) || value.slice(0, 6) !== digits.slice(0, 6)) {
      return i18n.t('invalid_first_six_chars', 'Ungültige erste sechs Zeichen') // Die ersten sechs Zeichen müssen mit der Ausfuhrtarifnummer übereinstimmen"
    }
    return undefined
  }
}

function getValidateZtn(name, type, mode, country) {
  if (!supportedZtnCountries.includes(country)) {
    return () => undefined
  }
  return (value, allValues) => {
    const ztnError = validateZtn(value, mode)
    if (ztnError) {
      return ztnError
    }
    const trace = lodash.get(allValues, `${name}.${type}Trace`)
    return validateTrace(trace)
  }
}

function validateTrace(value, allValues) {
  return !value || lodash.isEmpty(value)
    ? i18n.t(
        'invalid_ztn_trace',
        'Bitte geben Sie eine gültige Zolltarifnummer an',
      )
    : undefined
}

function validateZtn(value, mode) {
  const minChars = 8 // mode === "taric" ? 6 : 8
  return !value ||
    value === '' ||
    !lodash.isString(value) ||
    value.length < minChars
    ? i18n.t(
        'invalid_ztn_requirements',
        `Mindestens ${minChars} Zeichen angeben`,
      )
    : undefined
}
